import { useCallback, useMemo, useRef } from "react";
import { urlDecode, urlEncode } from "../utils";
export function useUrlState(props) {
    const { getEncodedState, handleDecodeError, onEncodedState } = props;
    const state = useRef(null);
    state.current = useMemo(() => {
        var _a;
        const encodedState = getEncodedState();
        try {
            return urlDecode(encodedState);
        }
        catch (e) {
            return (_a = handleDecodeError === null || handleDecodeError === void 0 ? void 0 : handleDecodeError(encodedState)) !== null && _a !== void 0 ? _a : null;
        }
    }, [getEncodedState, handleDecodeError]);
    const setState = useCallback(function setState(nextStateAction) {
        const newState = typeof nextStateAction === "function"
            ? nextStateAction(state.current)
            : nextStateAction;
        const hash = urlEncode(newState);
        onEncodedState(hash);
    }, [onEncodedState]);
    return [state.current, setState];
}
